import { render, staticRenderFns } from "./UserCode.vue?vue&type=template&id=12229fb9&scoped=true&"
import script from "./UserCode.vue?vue&type=script&lang=js&"
export * from "./UserCode.vue?vue&type=script&lang=js&"
import style0 from "./UserCode.vue?vue&type=style&index=0&id=12229fb9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12229fb9",
  null
  
)

export default component.exports